import React from 'react';
import {motion} from 'framer-motion';
import {config} from '../../config/jewelleryLandingConfig';

const VideoShowcase = () => {
  return (
    <section className="py-24 bg-cream">
      <div className="max-w-7xl mx-auto px-6 md:px-12 text-center">
        <h2 className="text-4xl md:text-5xl text-espresso mb-6">Dynamic Try-On Videos</h2>
        <p className="text-lg text-espresso/70 max-w-2xl mx-auto mb-16 font-light">
          Capture attention on social media and ad platforms with high-converting, motion-driven creative that showcases the drape, movement, and sparkle of your pieces.
        </p>
        <motion.div
          initial={{opacity: 0, y: 30}}
          whileInView={{opacity: 1, y: 0}}
          viewport={{once: true}}
          className="relative max-w-4xl mx-auto aspect-video bg-espresso overflow-hidden shadow-premium"
        >
          {config.media.videoShowcasePrimary.src ? (
            <video
              src={config.media.videoShowcasePrimary.src}
              poster={config.media.videoShowcasePrimary.poster}
              aria-label={config.media.videoShowcasePrimary.alt}
              className="w-full h-full object-cover opacity-90"
              autoPlay
              muted
              loop
              playsInline
            />
          ) : (
            <img
              src={config.media.videoShowcasePrimary.poster}
              alt={config.media.videoShowcasePrimary.alt}
              className="w-full h-full object-cover opacity-80"
              loading="lazy"
            />
          )}
        </motion.div>
      </div>
    </section>
  );
};

export default VideoShowcase;